import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/VerizonNHGTX-Bold.ttf";
import "./assets/fonts/VerizonNHGTX-Regular.ttf";
import { Provider } from "react-redux";
import store from "./store/index.jsx";
import ErrorBoundary from "./components/ErrorBoundary";

const root = createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Provider store={store} stabilityCheck="never">
      <App />
    </Provider>
  </ErrorBoundary>
);
